var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.is_logged_in)?_c('v-btn',{attrs:{"dark":"","block":"","color":"blue darken-2","href":_vm.login_url}},[_vm._v(" Login ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }